export { default, type ShowHideProps } from './ShowHide';
